// extracted by mini-css-extract-plugin
export var addToCartButton = "_oa-b";
export var arrowButtonContainer = "_oa-9";
export var arrowButtonIcon = "_oa-a";
export var carouselArrowButton = "_oa-6";
export var carouselElementContainer = "_oa-1";
export var left = "_oa-7";
export var productDisplayCarouselContainer = "_oa-0";
export var productTileContainer = "_oa-2";
export var productTileImage = "_oa-4";
export var productTileImageContainer = "_oa-3";
export var productTileTitle = "_oa-5";
export var right = "_oa-8";
export var sliderOverflow = "_oa-c";